import { render, staticRenderFns } from "./companyMing.vue?vue&type=template&id=22b6db70&scoped=true"
import script from "./companyMing.vue?vue&type=script&lang=js"
export * from "./companyMing.vue?vue&type=script&lang=js"
import style0 from "./companyMing.vue?vue&type=style&index=0&id=22b6db70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6db70",
  null
  
)

export default component.exports